import { API_URL } from "../Config/index.js";
import { emitEvent } from "../MasterData/emitter";

// Helper function to get auth token from localStorage
const getAuthToken = () => {
  return localStorage.getItem("authToken");
};

const handleSessionTimeout = (status, data) => {
  if (status === 401 && data?.sessionTimeout) {
    emitEvent("session-timeout", data);
    return true;
  }
  return false;
};

export const previewRunLaterPost = async (userData) => {
  try {
    const token = getAuthToken();
    const response = await fetch(`${API_URL}/manage-post/runPost`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...(token ? { Authorization: `${token}` } : {}),
      },
      body: JSON.stringify(userData),
    });

    // Get response details for better error handling
    const responseText = await response.text();
    let responseData;
    try {
      responseData = JSON.parse(responseText);
    } catch (e) {
      responseData = { message: responseText };
    }

    if (handleSessionTimeout(response.status, responseData)) {
      return {
        success: false,
        message: responseData.uiMsg || responseData.message || "Session timeout",
      };
    }

    if (!response.ok) {
      throw new Error(
        `API Error (${response.status}): ${
          responseData.message || responseText || "Unknown error"
        }`
      );
    }

    return responseData;
  } catch (error) {
    console.error("Error adding user:", error);
    throw error;
  }
};

export const submitForApprovalRunLaterPost = async (userData) => {
  try {
    const token = getAuthToken();
    const response = await fetch(`${API_URL}/manage-post/safeRun`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...(token ? { Authorization: `${token}` } : {}),
      },
      body: JSON.stringify(userData),
    });

    // Get response details for better error handling
    const responseText = await response.text();
    let responseData;
    try {
      responseData = JSON.parse(responseText);
    } catch (e) {
      responseData = { message: responseText };
    }

    if (handleSessionTimeout(response.status, responseData)) {
      return {
        success: false,
        message: responseData.uiMsg || responseData.message || "Session timeout",
      };
    }

    if (!response.ok) {
      throw new Error(
        `API Error (${response.status}): ${
          responseData.message || responseText || "Unknown error"
        }`
      );
    }

    return responseData;
  } catch (error) {
    console.error("Error adding user:", error);
    throw error;
  }
};

export const cancelScheduledPost = async (clientId, scheduleDateTime) => {
  try {
    const token = getAuthToken();
    const response = await fetch(`${API_URL}/manage-post/cancel-posting/${clientId}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...(token ? { Authorization: `${token}` } : {}),
      },
      body: JSON.stringify({
        clientId,
        scheduleDateTime,
      }),
    });

    // Get response details for better error handling
    const responseText = await response.text();
    let responseData;
    try {
      responseData = JSON.parse(responseText);
    } catch (e) {
      responseData = { message: responseText };
    }

    if (handleSessionTimeout(response.status, responseData)) {
      return {
        success: false,
        message: responseData.uiMsg || responseData.message || "Session timeout",
      };
    }

    if (!response.ok) {
      throw new Error(
        `API Error (${response.status}): ${
          responseData.message || responseText || "Unknown error"
        }`
      );
    }

    return responseData;
  } catch (error) {
    console.error("Error canceling post:", error);
    throw error;
  }
};
